import { useContext } from 'react';
import { AuthErrorContext } from '../contexts/AuthErrorContext.ts';

export const useUserAuthError = () => {
  const context = useContext(AuthErrorContext);
  if (context === undefined) {
    throw new Error(
      'useUserAuthError must be used within an AuthErrorProvider'
    );
  }
  return context;
};
